$( document ).ready(function() {
    'use strict';
    var sideList = document.querySelectorAll('.side-list');

    Array.prototype.forEach.call(sideList, function(val){
      val.classList.add('active');
    });
});
